var map = {
	"./appliances.webp": 31541,
	"./armchairs.webp": 13167,
	"./beds.webp": 75853,
	"./benches.webp": 12549,
	"./blinds.webp": 101,
	"./cabinets.webp": 13092,
	"./chairs.webp": 21407,
	"./curtains.webp": 24686,
	"./decor.webp": 20010,
	"./desks.webp": 20489,
	"./dressers.webp": 74584,
	"./electronics.webp": 25272,
	"./fireplaces.webp": 67001,
	"./fixtures.webp": 23399,
	"./lighting.webp": 23553,
	"./mirrors.webp": 39287,
	"./nightstands.webp": 23120,
	"./ottomans.webp": 21730,
	"./plants.webp": 73319,
	"./rugs.webp": 32378,
	"./shelves.webp": 67207,
	"./sideboards.webp": 39403,
	"./sofas.webp": 62875,
	"./stools.webp": 30717,
	"./tables.webp": 10464,
	"./tv stands.webp": 16908,
	"./wardrobes.webp": 72218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84073;